export enum OfferProductLevel {
    PREMIUM = 0,
    FREE = 1
}